/** Per-page fallback for browsers that deny access to persistent storage. */
export function resilientStorage(resolve: () => Storage): Storage {
  const memory = new Map<string, string>();
  let unavailable = false;
  function access<T>(operation: (storage: Storage) => T, fallback: () => T): T {
    if (!unavailable) {
      try {
        return operation(resolve());
      } catch {
        unavailable = true;
      }
    }
    return fallback();
  }
  return {
    get length() {
      return access(
        (storage) => storage.length,
        () => memory.size
      );
    },
    key(index) {
      return access(
        (storage) => storage.key(index),
        () => [...memory.keys()][index] ?? null
      );
    },
    getItem(key) {
      return access(
        (storage) => storage.getItem(key),
        () => memory.get(key) ?? null
      );
    },
    setItem(key, value) {
      memory.set(key, value);
      access(
        (storage) => storage.setItem(key, value),
        () => undefined
      );
    },
    removeItem(key) {
      memory.delete(key);
      access(
        (storage) => storage.removeItem(key),
        () => undefined
      );
    },
    clear() {
      memory.clear();
      access(
        (storage) => storage.clear(),
        () => undefined
      );
    },
  };
}

export const localPreferences = resilientStorage(() => window.localStorage);
